(($, Drupal) => {
  "use strict";

  function handleFormSubmission(context, formId, loadingText) {
    const formWrapper = context.querySelector(formId);
    if (!formWrapper) return;

    formWrapper.addEventListener('submit', () => {
      const submitButton = formWrapper.querySelector('.form-submit');
      if (!submitButton) return;

      submitButton.classList.add('disabled');
      submitButton.textContent = Drupal.t(loadingText);
    });
  }

  Drupal.behaviors.buttonStatusText = {
    attach(context) {
      handleFormSubmission(
        context,
        '#olexai-feedback-form',
        'Olex is getting ready'
      );

      handleFormSubmission(
        context,
        '#olexai-imaginator-form',
        'Olex is getting his paint brushes ready'
      );

      handleFormSubmission(
        context,
        '#olexai-lesson-plan-form',
        'Generating lesson plan'
      );
    },
  };
})(jQuery, Drupal);
